import { ROUTER } from '../helpers/RouterApi';
import { BackEndHelper } from '../helpers/BackEndHelper';

export const MiniSitesServices = {
    getListDomain,
    getListEvents,
    getListMiniSites,
    isValidSubdomain,
    saveMiniSites,
    getBackofficeUrl,
    getMiniSite,
    getSearchEvents,
    getSearchNotifications,
    updateMiniSites
};

function getListDomain() {
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_MINISITES_DOMAINS);
}

function isValidSubdomain(dataRequest) {
    let request = {
        domainName: dataRequest.subdomainCompare
    };
    return BackEndHelper.request('POST', ROUTER.ROUTE_API_MINISITES_DOMAINS_VALIDATION, request);
}

function getListEvents(dataRequest) {
    let data = {
        description: dataRequest.description,
        pageNumber: dataRequest.pageNumberEventList,
        pageSize: dataRequest.pageSizeEventList
    }
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_EVENTS, data);
}

function saveMiniSites(dataRequest) {
    return BackEndHelper.request('POST', ROUTER.ROUTE_API_MINISITES, dataRequest, false);

}

function getBackofficeUrl() {
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_URLS);
}

function getListMiniSites(dataRequest) {
    let data = {
        pageNumber: dataRequest.pageNumberMinisiteList,
        pageSize: dataRequest.pageSizeMinisiteList
    }
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_MINISITES, data);
}

function getMiniSite(dataRequest) {
    let data = {
        idMinisite: dataRequest.idMinisite
    }
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_MINISITES, data);
}

function getSearchEvents(dataRequest) {
    let data = {
        description: dataRequest.description
    }
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_EVENTS, data);
}

function getSearchNotifications() {
    return BackEndHelper.request('GET', ROUTER.ROUTE_API_MINISITES_MANDRILL);
}

function updateMiniSites(dataRequest) {
    return BackEndHelper.request('PUT', ROUTER.ROUTE_API_MINISITES, dataRequest, false);
}